export default {
  toastr (state) {
    return state.toastr
  }
}



// WEBPACK FOOTER //
// ./src/store/toastr/getters.js